import { TpvMemphisOperator } from '@app/domain/models/tpv/memphis-operator.model';
import { MemphisOperatorDto } from '@app/data/dtos/tpv/memphis-operator.dto';

/** DTO de operador Memphis -> entidad de dominio (con fallbacks por claves variantes). */
export function mapMemphisOperator(dto: MemphisOperatorDto): TpvMemphisOperator {
  const name = dto.name ?? dto.first_name ?? '';
  const paternal = dto.last_name_paternal ?? '';
  const maternal = dto.last_name_maternal ?? '';
  const fullName = (dto.full_name ?? `${name} ${paternal} ${maternal}`).trim();
  const active = typeof dto.active === 'boolean'
    ? dto.active
    : (dto.status ?? '').toString().toUpperCase() === 'ACTIVO';

  return {
    idOperador: String(dto.id_operador ?? dto.id_operator ?? ''),
    name,
    lastNamePaternal: paternal,
    lastNameMaternal: maternal,
    fullName,
    email: dto.email ?? '',
    active,
    createdAt: dto.created_at ?? '',
    updatedAt: dto.updated_at ?? '',
    idUserMemphis: dto.id_user_memphis != null ? Number(dto.id_user_memphis) : null,
  };
}
